import UpController from './UpController';

export default UpController;
